import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

const param = { offset: 0, limit: 12 };

// Bookmark Restaurant
export function* loadBookmarkRestaurantList() {
  yield takeEvery(
    actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST,
    function* (action) {
      try {
        const response = yield API.loadBookmarkRestaurantList(action.data);
        if (response.data.success) {
          yield put(
            actions.loadBookmarkRestaurantListSuccess(response.data.data)
          );
        } else {
          yield put(actions.loadBookmarkRestaurantListFail());
          alert(
            "Warning: Fail to load bookmark restaurant. \n" +
              response.data.message
          );
        }
      } catch (error) {
        // console.log(
        //   API.constructErrMsg(
        //     "Error: Fail to load bookmark restaurant. \n" + error
        //   )
        // );
        yield put(actions.loadBookmarkRestaurantListFail());
      }
    }
  );
}

export function* substituteBookmarkRestaurant() {
  yield takeEvery(
    actionTypes.SUBSTITUTE_BOOKMARK_RESTAURANT,
    function* (action) {
      try {
        const response = yield API.substituteBookmarkRestaurant(action.data);
        if (response.data.success) {
          yield put(actions.substituteBookmarkRestaurantSuccess());
          yield put(actions.toastSuccess(response.data.message));
          yield put(actions.loadBookmarkRestaurantList());
        } else {
          yield put(actions.substituteBookmarkRestaurantFail());
          alert("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.substituteBookmarkRestaurantFail());
      }
    }
  );
}

// Don't Show Restaurant
export function* loadDislikeRestaurantList() {
  yield takeEvery(actionTypes.LOAD_DISLIKE_RESTAURANT_LIST, function* (action) {
    try {
      const response = yield API.loadDislikeRestaurantList(action.data);
      if (response.data.success) {
        yield put(actions.loadDislikeRestaurantListSuccess(response.data.data));
      } else {
        yield put(actions.loadDislikeRestaurantListFail());
        alert(
          "Warning: Fail to load don't show restaurant. \n" +
            response.data.message
        );
      }
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to load don't show restaurant. \n" + error
      //     )
      //   );
      yield put(actions.loadDislikeRestaurantListFail());
    }
  });
}

export function* substituteDislikeRestaurant() {
  yield takeEvery(
    actionTypes.SUBSTITUTE_DISLIKE_RESTAURANT,
    function* (action) {
      try {
        const response = yield API.substituteDislikeRestaurant(action.data);
        if (response.data.success) {
          yield put(actions.substituteDislikeRestaurantSuccess());
          yield put(actions.toastSuccess(response.data.message));
          yield put(actions.loadDislikeRestaurantList());
        } else {
          yield put(actions.substituteDislikeRestaurantFail());
          alert("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.substituteDislikeRestaurantFail());
      }
    }
  );
}

// View History Restaurant
export function* loadViewHistoryRestaurantList() {
  yield takeEvery(
    actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST,
    function* (action) {
      try {
        const response = yield API.loadViewHistoryRestaurantList(action.data);
        if (response.data.success) {
          yield put(
            actions.loadViewHistoryRestaurantListSuccess(response.data.data)
          );
        } else {
          yield put(actions.loadViewHistoryRestaurantListFail());
          alert(
            "Warning: Fail to load view history restaurant. \n" +
              response.data.message
          );
        }
      } catch (error) {
        // console.log(
        //   API.constructErrMsg(
        //     "Error: Fail to load view history restaurant. \n" + error
        //   )
        // );
        yield put(actions.loadViewHistoryRestaurantListFail());
      }
    }
  );
}

export function* insertViewHistoryRestaurant() {
  yield takeEvery(
    actionTypes.INSERT_VIEW_HISTORY_RESTAURANT,
    function* (action) {
      try {
        const response = yield API.insertViewHistoryRestaurant(action.data);
        if (response.data.success) {
          yield put(actions.insertViewHistoryRestaurantSuccess());
        } else {
          yield put(actions.insertViewHistoryRestaurantFail());
          //   console.log("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.insertViewHistoryRestaurantFail());
      }
    }
  );
}

export function* deleteViewHistoryRestaurant() {
  yield takeEvery(
    actionTypes.DELETE_VIEW_HISTORY_RESTAURANT,
    function* (action) {
      try {
        const response = yield API.deleteViewHistoryRestaurant(action.data);
        if (response.data.success) {
          yield put(actions.deleteViewHistoryRestaurantSuccess());
          yield put(actions.toastSuccess(response.data.message));
          yield put(actions.loadViewHistoryRestaurantList(param));
        } else {
          yield put(actions.deleteViewHistoryRestaurantFail());
          alert("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.deleteViewHistoryRestaurantFail());
      }
    }
  );
}

export function* deleteViewHistoryRestaurantList() {
  yield takeEvery(
    actionTypes.DELETE_VIEW_HISTORY_RESTAURANT_LIST,
    function* () {
      try {
        const response = yield API.deleteViewHistoryRestaurantList();
        if (response.data.success) {
          yield put(actions.deleteViewHistoryRestaurantListSuccess());
          yield put(actions.toastSuccess(response.data.message));
          yield put(actions.loadViewHistoryRestaurantList(param));
        } else {
          yield put(actions.deleteViewHistoryRestaurantListFail());
          alert("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.deleteViewHistoryRestaurantListFail());
      }
    }
  );
}

// Remove Multiple

export function* deleteMultipleBookmarkOrDislikeRestaurant() {
  yield takeEvery(
    actionTypes.DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT,
    function* (action) {
      try {
        const response = yield API.deleteMultipleBookmarkOrDislikeRestaurant(
          action.data
        );
        if (response.data.success) {
          yield put(actions.deleteMultipleBookmarkOrDislikeRestaurantSuccess());
          yield put(actions.toastSuccess(response.data.message));
          if (action.data.action === "bookmark") {
            yield put(actions.loadBookmarkRestaurantList(param));
          } else {
            yield put(actions.loadDislikeRestaurantList(param));
          }
        } else {
          yield put(actions.deleteMultipleBookmarkOrDislikeRestaurantFail());
          alert("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.deleteMultipleBookmarkOrDislikeRestaurantFail());
      }
    }
  );
}

// Remove All
export function* deleteBookmarkOrDislikeRestaurantList() {
  yield takeEvery(
    actionTypes.DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST,
    function* (action) {
      try {
        const response = yield API.deleteBookmarkOrDislikeRestaurantList(
          action.data
        );
        if (response.data.success) {
          yield put(actions.deleteBookmarkOrDislikeRestaurantListSuccess());
          yield put(actions.toastSuccess(response.data.message));
          if (action.data.action === "bookmark") {
            yield put(actions.loadBookmarkRestaurantList(param));
          } else {
            yield put(actions.loadDislikeRestaurantList(param));
          }
        } else {
          yield put(actions.deleteBookmarkOrDislikeRestaurantListFail());
          alert("Warning: Fail. \n" + response.data.message);
        }
      } catch (error) {
        // console.log(API.constructErrMsg("Error: Fail. \n" + error));
        yield put(actions.deleteBookmarkOrDislikeRestaurantListFail());
      }
    }
  );
}

export default function* preferenceSaga() {
  yield all([
    fork(loadBookmarkRestaurantList),
    fork(substituteBookmarkRestaurant),
    fork(loadDislikeRestaurantList),
    fork(substituteDislikeRestaurant),
    fork(loadViewHistoryRestaurantList),
    fork(insertViewHistoryRestaurant),
    fork(deleteViewHistoryRestaurant),
    fork(deleteViewHistoryRestaurantList),
    fork(deleteMultipleBookmarkOrDislikeRestaurant),
    fork(deleteBookmarkOrDislikeRestaurantList),
  ]);
}
